export const session = {
  get: (key: string) => {
    const v = sessionStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  },
  set: (key: string, value: any) =>
    sessionStorage.setItem(key, JSON.stringify(value)),
  remove: (key: string) => sessionStorage.removeItem(key),
};
